import { Internship } from '../interfaces/store';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

type InternshipPdfProps = {
  internships: Internship[];
  fontColor: string;
};

const styles = StyleSheet.create({
  page: {
    padding: 0,
    fontSize: 12,
  },
  row: {
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  headingLabel: {
    fontSize: '21',
    fontWeight: '500',
    paddingTop: '9',
    paddingBottom: '9',
    color: 'black'
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    padding: '6',
    width: '90%',
    color: 'black'
  },
  experienceBlock: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottom: '1 solid #ccc',
  },
  roleTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    width: '70%',
    color: 'black'
  },
  dateLine: {
    fontSize: 10,
    color: 'black',
    marginBottom: 4,
  },
  description: {
    fontSize: 11,
    lineHeight: 1.5,
    color: 'black'
  },
});

export const InternshipPdf: React.FC<InternshipPdfProps> = ({ internships, fontColor }: InternshipPdfProps) => {
  const t = internships.map((v, i) => {
    let dateRange = `${v.startDate} - ${v.present ? 'Present' : v.endDate || ''}`;
    let locationLine = v.company ? `${v.company} — ${v.city}` : v.city;

    if (v.role === '') {
      dateRange = ''
      locationLine = ''
    }
    
    if (fontColor) {
      styles.headingLabel.color = fontColor
      styles.text.color = fontColor
      styles.roleTitle.color = fontColor
      styles.dateLine.color = fontColor
      styles.description.color = fontColor
    }

    return (
      <View key={i} style={styles.experienceBlock}>
        <View style={styles.flex}>
          <Text style={styles.roleTitle}>{v.role}</Text>
          <Text style={styles.dateLine}>{dateRange}</Text>
        </View>
        <Text style={[styles.text, { padding: 0 }]}>{locationLine}</Text>
        <Text style={styles.description}>{v.description}</Text>
      </View>
    );
  });

  return <View>{t}</View>;
};
